
<template>
  <div style="font-family: 'Roboto Slab', serif">
    <div v-if="Request == null || Request == '' || Request == undefined">
      <center class="loading-medium">
        <loading></loading>
      </center>
    </div>
    <div
      v-if="Request"
      style="
        width: 800px;
        height: 1250px;
        border: 1px solid black;
        margin: auto;
        padding: 20px;
        font-size: 14px;
      "
    >
      <div style>
        <div class="col-xs-3">
          <img
            src="../../assets/imgs/png/FAJRLOGO01.png"
            style="float: left; height: 90px; width: 130px"
          />
        </div>
        <div class="col-xs-6">
          <h3
            style="
              font-weight: 500;
              margin-top: 60px;
              font-size: 28px;
              font-family: 'Roboto Slab', serif;
            "
          >
            HOLDING CERTIFICATE
          </h3>
        </div>
        <div class="col-xs-3">
          <img
            src="../../assets/imgs/arabic-logo.jpg"
            style="float: right; height: 90px; width: 130px"
          />
        </div>
      </div>
      <br clear="all" />
      <!-- <h2
      style="text-align:center;padding-bottom:0;border-top:solid 1px #000;margin-bottom:2px;padding-bottom:5px;padding-top:5px;border-bottom:solid 1px #000;"
      >SELLER'S OFFER</h2>-->

      <!-- <div style="padding-top:0;margin-top:0;height:1px;border-top:solid 1px #000;margin-top:1px"></div> -->
      <hr style="border: 1.2px solid #b35900" />

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-12" style="text-align: justify">
            We confirm that
            <b>Fajr Investment Advisory B.S.C</b> was the sole legal owner of
            the Commodity below held at Loco Hong Kong, China immediately before
            transfer of legal title to <b>{{ Request.BankName }}</b>
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">Commodity:</div>
          <div class="col-xs-7">{{ Request.CommodityName }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">
            Commodity Description:
          </div>
          <div class="col-xs-7">99.95% pt - 'Good Delivery'</div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">Location:</div>
          <div class="col-xs-7">{{ Request.SupplierLocation }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">Total Price:</div>
          <div class="col-xs-7">
            {{ Request.CurrencyShortname }} {{ Request.StringAmount }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">Price per Unit:</div>
          <div class="col-xs-7">
            {{ Request.CurrencyShortname }} {{ Request.StringUnitPrice }}
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">Quantity:</div>
          <div class="col-xs-7">
            {{ Request.StringQuantity }} {{ Request.UnitName }}
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">
            Commodity Adminstration Fee:
          </div>
          <div class="col-xs-7">
            {{ Request.CurrencyShortname == "SAR" ? "SAR" : "USD" }}&nbsp;{{
              Request.CurrencyShortname == "SAR"
                ? Request.SARCommission.toFixed(2)
                : Request.USDCommission.toFixed(2)
            }}
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">
            Transaction Ref. No.:
          </div>
          <div class="col-xs-7">{{ Request.RefNo }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">Contract Date:</div>
          <div class="col-xs-7">
            {{ Timestrap(Request.ApplicationDate) }}
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">Value Date:</div>
          <div class="col-xs-7">{{ DateFromat(Request.ValueDate, true) }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">As Agent For</div>
          <div class="col-xs-7">
            {{
              Request.ClientName == null || Request.ClientName == ""
                ? "N/A"
                : Request.ClientName
            }}
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5">
            <b> Warehouse</b> <br />
            {{ Request.SupplierLocation }}
          </div>
          <div class="col-xs-7">
            <b>Quantity</b>&nbsp;&nbsp;&nbsp;&nbsp;{{ Request.StringQuantity }}
            <br />
            <b>Total</b>&nbsp;&nbsp;{{ Request.StringQuantity }}&nbsp;&nbsp;
            <b>{{ Request.UnitName }}</b>
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-12" style="text-align: justify">
            <p>
              The Commodity identified above has been allocated and sold to
              <b>{{ Request.BankName }}</b> , Riyadh only on
              <b>{{ DateFromat(Request.ApplicationDate, true) }}</b> for value
              on <b>{{ DateFromat(Request.ValueDate, true) }}</b
              >.
            </p>
            <p style="margin-top: 15px">
              As of the Value Date, legal title to the Commodity is transferred
              to <b>{{ Request.BankName }}</b> and the Commodity identified
              above is held in storage by us for the account of
              <b>{{ Request.BankName }}</b> pending receipt of further
              instructions from <b>{{ Request.BankName }}</b
              >.
            </p>
            <p style="margin-top: 15px">
              <b>{{ Request.BankName }}</b> shall be liable for any storage and
              safe custody charges, which shall arise if the Commodity is held
              by us for its account for more than one London business day from
              the Value Date.
            </p>
            <p style="margin-top: 15px">
              <b>{{ Request.BankName }}</b> shall be responsible for risks
              associated with the ownership of the Commodity as long as the
              Commodity is held for <b>{{ Request.BankName }}</b
              >.
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-12">
            <br />For and on behalf of
            <br />
            <b>Fajr Investment Advisory B.S.C.(c)</b>
            <br />
          </div>
        </div>
      </div>
      <br />
      <br />
      <br />
      <p style="text-align: center; font-size: 10px; margin-bottom: -15px">
        <em style="font-size: 16px"
          >This is a computer generated document, issued by a secure platform
          and as such, does not require a signature.</em
        >
      </p>
      <hr style="border: 1px solid #b35900" />
      <p style="font-size: 14px; text-align: center; margin-top: -30px">
        <br />P.O.Box 10797 - Manama,Kingdom of Bahrain, Tel: +973 17 540600,
        www.fajr.com.bh C.R.-68481
      </p>
    </div>
  </div>
</template>

<style scoped>
* {
  font-size: 18px;
}
</style>

  <script>
import { mapGetters, mapState } from "vuex";
export default {
  computed: {
    ...mapGetters({
      Request: "GETBUYREQUEST",
      AggrementDate: "GETAGGREMENTDATE",
    }),
  },
};
</script>
<style scopped>
tr td {
  border: 0;
}
.Details > tr > td:nth-child(odd) {
  width: 26%;
}
</style>
